import './EnlaceTemas.css'

function EnlaceTemas (props) {

    return (
        <div className='enlacetemas'>
            <a className='enlace' href="https://www.tutorialesprogramacionya.com/herramientas/javascript/basico/">Básico</a>
            <a className='enlace' href="https://www.tutorialesprogramacionya.com/herramientas/javascript/funcion/">funciones</a>
            <a className='enlace' href="https://www.tutorialesprogramacionya.com/herramientas/javascript/string/">string</a>            
            <a className='enlace' href="https://www.tutorialesprogramacionya.com/herramientas/javascript/array/">array</a>
            <a className='enlace' href="https://www.tutorialesprogramacionya.com/herramientas/javascript/objeto/">objetos</a>
            <a className='enlace' href="https://www.tutorialesprogramacionya.com/herramientas/javascript/json/">JSON</a>            
            <a className='enlace' href="https://www.tutorialesprogramacionya.com/herramientas/javascript/javascriptasincrono/">JavaScript asíncrono</a>
            <a className='enlace' href="https://www.tutorialesprogramacionya.com/herramientas/javascript/regexp/">RegExp</a>            
        </div>
    )
}

export default EnlaceTemas;